import React from 'react';
import { Row, Col, Form, Card } from 'react-bootstrap';

/**
 * Araç formlarında kullanılan Araç Durumu formu
 * 
 * @param {Object} props.data - Form verisi (formData veya vehicle)
 * @param {Function} props.handleChange - Input değişikliklerini yakalayan fonksiyon
 */
const VehicleBodyConditionForm = ({ data, handleChange }) => {
    // Parça durumu seçenekleri
    const conditionOptions = [
        { value: "", label: "Seçiniz" },
        { value: "Orijinal", label: "Orijinal" },
        { value: "Boyalı", label: "Boyalı" },
        { value: "Değişen", label: "Değişen" },
        { value: "Lokal", label: "Lokal" }
    ];

    // Tekrar eden select bileşenini render etmek için yardımcı fonksiyon
    const renderConditionSelect = (label, fieldName) => (
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>
            <Form.Select
                name={`bodyCondition.${fieldName}`}
                value={data.bodyCondition?.[fieldName] || ''}
                onChange={handleChange}
            >
                {conditionOptions.map((option) => (
                    <option key={`${fieldName}-${option.value}`} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Select>
        </Form.Group>
    );

    return (
        <Card className="mb-4">
            <Card.Header>Araç Durumu</Card.Header>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        {renderConditionSelect("Ön Tampon", "frontBumper")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Arka Tampon", "rearBumper")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Tavan", "roof")}
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        {renderConditionSelect("Bagaj Kaputu", "trunkLid")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Motor Kaputu", "engineHood")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Sol Ön Kapı", "leftFrontDoor")}
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        {renderConditionSelect("Sağ Ön Kapı", "rightFrontDoor")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Sol Arka Kapı", "leftRearDoor")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Sağ Arka Kapı", "rightRearDoor")}
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        {renderConditionSelect("Sol Ön Çamurluk", "leftFrontFender")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Sağ Ön Çamurluk", "rightFrontFender")}
                    </Col>
                    <Col md={4}>
                        {renderConditionSelect("Sol Arka Çamurluk", "leftRearFender")}
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        {renderConditionSelect("Sağ Arka Çamurluk", "rightRearFender")}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default VehicleBodyConditionForm;